import { Button } from '@mui/material';
import { GridCellParams, GridColDef } from '@mui/x-data-grid';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { Page, RowActions, SortOrder, Table, useQueryParamsContext } from '../../../shared';
import { useDeleteIncomeType, useIncomeTypesList } from '../../hooks/income-type.hook';

export const IncomeTypesPage: FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const {
        queryParams: { page, pageSize, sort },
        setPage,
        setPageSize,
        setSort,
    } = useQueryParamsContext('income-types', {
        sort: [{ field: 'name', sort: 'asc' }],
    });

    const { data: incomeTypes, isPending } = useIncomeTypesList({
        page,
        pageSize,
        sortBy: sort[0].field,
        sortOrder: sort[0].sort?.toUpperCase() as SortOrder,
    });
    const { mutateAsync: deleteIncomeType } = useDeleteIncomeType();

    const columns: GridColDef[] = [
        { field: 'name', headerName: t('nameLabel'), flex: 1 },
        {
            field: 'actions',
            headerName: t('actions'),
            width: 100,
            align: 'right',
            sortable: false,
            renderCell: ({ row: { id } }: GridCellParams) => (
                <RowActions
                    onEdit={() => navigate(`/admin/income-types/${id}/edit`)}
                    onDelete={() => deleteIncomeType({ id })}
                    deleteWarningTitle={t('incomeTypeDeleteWarningTitle')}
                    deleteWarningText={t('incomeTypeDeleteWarningText')}
                />
            ),
        },
    ];
    return (
        <Page
            title={t('incomeTypes')}
            actions={
                <Button component={Link} to="/admin/income-types/new" color="primary" variant="contained">
                    {t('newIncomeType')}
                </Button>
            }
        >
            <Table
                rows={incomeTypes?.data || []}
                columns={columns}
                rowCount={incomeTypes?.pagination?.size || 0}
                page={page}
                pageSize={pageSize}
                setPage={setPage}
                setPageSize={setPageSize}
                loading={isPending}
                sortModel={sort}
                onSortModelChange={setSort}
            />
        </Page>
    );
};
